<template>
  <div id="cat" v-cloak>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row mb-2">
          <div class="vx-col lg:w-1/3 w-full">
            <label class="vs-select--label">{{ $t("UserId") }}</label>
            <vs-input
              name="user"
              v-model="gridSearchData.UserName"
              @keyup.enter="searchUserName()"
            />
          </div>
          <div class="vx-col lg:w-1/6 w-full">
            <vs-button
              class="mt-6 p-2"
              color="success"
              type="gradient"
              icon-pack="feather"
              icon="icon-search"
              @click.prevent="searchUserName()"
            ></vs-button>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('UserId') },
                { title: $t('UserName'), sort: 'UserName' },
                { title: $t('UserId'), sort: 'UserId' },
                { title: $t('IsActive'), sort: 'IsActive' },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action'), sort: 'Action' },
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">
                  {{ row.userName }}
                </td>
                <td style="width: 14%">
                  <span v-if="row.userClaims[0]">
                    <span v-if="row.userClaims[3]">
                      <span
                        v-if="
                          row.userClaims[3].key == ('nickname' || 'profile')
                        "
                        >{{ row.userClaims[3].value }}</span
                      >
                    </span>
                    <span v-if="row.userClaims[2]">
                      <span
                        v-if="
                          row.userClaims[2].key == ('nickname' || 'profile')
                        "
                        >{{ row.userClaims[2].value }}</span
                      >
                    </span>
                    <span v-if="row.userClaims[1]">
                      <span
                        v-if="
                          row.userClaims[1].key == ('nickname' || 'profile')
                        "
                        >{{ row.userClaims[1].value }}</span
                      >
                    </span>
                    <span v-if="row.userClaims[0]">
                      <span
                        v-if="
                          row.userClaims[0].key == ('nickname' || 'profile')
                        "
                        >{{ row.userClaims[0].value }}</span
                      >
                    </span>
                  </span>
                  <span v-else>----</span>
                </td>
                <td style="width: 12%">
                  {{ row.id }}
                </td>
                <td style="width: 16%">
                  <vs-checkbox
                    v-model="row.isActive"
                    disabled="true"
                  ></vs-checkbox>
                </td>
                <td style="width: 15%">
                  {{ row.createOn.split(" ")[0] }}<br />{{
                    row.createOn.split(" ")[1]
                  }}
                </td>
                <td style="width: 20%">
                  <vs-button
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-edit"
                    class="simple-bordered-btn"
                    @click.prevent="rolePopup(row.id)"
                    v-has-permission="permission156"
                    >{{ $t("Roles") }}</vs-button
                  >
                </td>
              </template>
            </data-grid>
            <role-popup
              :show="RolePopup"
              @finish="onRoleFinish"
              :userId="userId"
              :roleModel="roleModel"
            ></role-popup>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
.vs-checkbox {
  margin: 0 auto;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import RolePopup from "./RolePopup.vue";
export default {
  name: "user-management-Users-Index",
  components: {
    DataGrid,
    RolePopup,
  },
  data() {
    return {
      permission156: "GetAllUserByUserId",
      UserName: "",
      gridDataSource: {
        type: "app",
        service: "IdentityAccess/api/UsersQuery",
      },
      gridSearchData: {
        UserName: "",
      },
      RolePopup: false,
      roleModel: [],
      userId: null,
    };
  },
  computed: {
    ...mapGetters({
      userRoles: "user/details",
    }),
  },
  methods: {
    ...mapActions({
      fetchByRoleId: "user/fetchByRoleId",
      searchWithUsername: "user/fetch",
    }),
    searchUserName() {
      this.$refs.grid.renderGrid(1, true);
    },
    rolePopup(id) {
      this.fetchByRoleId(id).then(() => {
        this.roleModel = JSON.parse(JSON.stringify(this.userRoles));
      });
      this.userId = id;
      this.RolePopup = true;
    },
    onRoleFinish() {
      this.RolePopup = false;
    },
  },
};
</script>
